export const lectureMaterials=[
    {
        No:1,
        CourseCode:'CPT211',
    },
    {
        No:2,
        CourseCode:'CPT213',
    },
    {
        No:3,
        CourseCode:'CPT214',
    },
    {
        No:4,
        CourseCode:'CSS216',
    },
    {
        No:5,
        CourseCode:'GST211',
    },
    {
        No:6,
        CourseCode:'MAT212',
    },
    {
        No:7,
        CourseCode:'MAT216',
    },
    {
        No:8,
        CourseCode:'STA217',
    },
    {
        No:9,
        CourseCode:'PHY216',
    },
    {
        No:10 ,
        CourseCode:'CIT224',
    },
    {
        No: 11,
        CourseCode:'CPT221',
    },
    {
        No:12 ,
        CourseCode:'CPT222',
    },
    {
        No: 13,
        CourseCode:'CPT223',
    },
    {
        No:14 ,
        CourseCode:'CPT224',
    },
    {
        No:15 ,
        CourseCode:'CPT226',
    },
    {
        No:16 ,
        CourseCode:'MAT222',
    },
    {
        No:17 ,
        CourseCode:'MAT225',
    },
    {
        No:18 ,
        CourseCode:'CSS226',
    },
]